import type { ReactNode } from 'react'

interface Props {
  color?: string
  size?: number
}

export function CloseIcon({ color = '#63a4f8', size = 36 }: Props): ReactNode {
  return (
    <svg height={size} width={size} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36">
      <polygon
        fill={color}
        points="27.661 9.366 26.325 8 18 16.63 9.675 8 8.339 9.366 16.661 18 8.339 26.634 9.675 28 18 19.37 26.325 28 27.661 26.634 19.339 18 27.661 9.366"
      />
    </svg>
  )
}
